document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.academy-topics').forEach(function (track) {
    let isDown = false;
    let moved = false;
    let startX = 0;
    let scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      moved = false;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = x - startX;
      if (Math.abs(walk) > 5) moved = true;
      track.scrollLeft = scrollLeft - walk;
    });

    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    const wrapper = track.closest('.academy-topics-scroll');
    if (!wrapper) return;

    const prevArrow = wrapper.querySelector('.academy-topics-arrow--prev');
    const nextArrow = wrapper.querySelector('.academy-topics-arrow--next');
    if (!prevArrow && !nextArrow) return;

    function updateArrows() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const overflows = maxScroll > 1;
      if (prevArrow) prevArrow.classList.toggle('is-visible', overflows && track.scrollLeft > 1);
      if (nextArrow) nextArrow.classList.toggle('is-visible', overflows && track.scrollLeft < maxScroll - 1);
    }

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        track.scrollBy({ left: -200, behavior: 'smooth' });
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        track.scrollBy({ left: 200, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
});
